import React from "react";
import styled from "@emotion/styled";
import BasicButton from "@components/button/BasicButton";
import { useTheme } from "@emotion/react";
import { Flex } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "2.4rem",
  padding: "8rem 2rem",

  ".title": {
    fontSize: "2rem",
    fontWeight: "bold",
  },
});

const SubtitleBox = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "0.4rem",
  color: theme.color.light_gray,
}));

const ButtonWrapper = styled.div(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  gap: "1.2rem",
  marginTop: "2rem",
}));

const CommentBox = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: " center",
  gap: "2.4rem",
  lineHeight: "2.1rem",
  padding: "1.2rem 4.2rem",
}));

const PleaseLogin = () => {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavigate = (route: string) => {
    navigate(route, {
      replace: true,
    });
  };

  return (
    <Container>
      <span className="title">{"로그인을 해주세요"}</span>

      <SubtitleBox>
        <span className="subtitle">로그인 또는 회원가입 후</span>
        <span className="subtitle">SHAKALAKA의 다양한 혜택을 누려보세요.</span>
      </SubtitleBox>

      <ButtonWrapper>
        <BasicButton
          title="회원가입"
          width="50%"
          onClick={() => handleNavigate("/verify-email")}
        />
        <BasicButton
          title="로그인"
          width="50%"
          bgColor={theme.color.light_gray}
          onClick={() => handleNavigate("/login")}
        />
      </ButtonWrapper>

      <CommentBox>
        <Flex vertical align="center" justify="center">
          <span>{"무료로 회원가입하고"}</span>
          <span>{"지속가능한 패션리더가 되어보아요!🚀"}</span>
        </Flex>

        {location.pathname === "/saved" && (
          <span>{"✔️마음에 드는 상품/ 브랜드/ 셀러 찜하기"}</span>
        )}

        {location.pathname === "/main-register" && (
          <Flex vertical align="center" justify="center">
            <span>{"✔️좋아하는 도매스틱 브랜드의 리세일 상품들"}</span>
            <span>{"도매가격으로 만나보세요!"}</span>
          </Flex>
        )}

        {location.pathname === "/my-page" && (
          <Flex vertical align="center" justify="center">
            <span>{"✔️팔로팔로미~"}</span>
            <span>
              {"취향, 체격이 비슷한 커뮤니티 멤버들을 만날 수 있어요!"}
            </span>
          </Flex>
        )}
      </CommentBox>
    </Container>
  );
};

export default PleaseLogin;
